import React from "react";
import { formatKm } from "../../../utilities/distanceUtils";

interface Props {
  segment: server.dto.FlightSegment
}

const PrivateFlightDetails = (props: Props) => {
  const { segment } = props;
  return <>
    {(segment.access || null) && <tr>
      <td>Access </td>
      <td>
        <div>{segment.access}</div>
      </td>
    </tr>}
    {(segment.distance.meter > 0) &&
            <tr>
              <td>{RESX.Flight.Distance}</td>
              <td>{formatKm(segment.distance, 0)}</td>
            </tr>
    }
    {(segment.aircraft || null) && <tr>
      <td>{RESX.Flight.Aircraft}</td>
      <td>{segment.aircraft}</td>
    </tr>}
    {(segment.confirmationNumber) && <tr>
      <td>{RESX.Flight.ConfirmationNumber}</td>
      <td>{segment.confirmationNumber}</td>
    </tr>}
    {(segment.capacity?.formatted) && <tr>
      <td>{RESX.Venue.Capacity} </td>
      <td>{segment.capacity.formatted}</td>
    </tr>}
  </>;
};

export default PrivateFlightDetails;
